import './assets/fonts.css'
import './assets/index.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './views/portal/routes'

const app = createApp(App)

app.use(createPinia())
app.use(
    createRouter({
        history: createWebHistory(),
        routes: [...routes],
    }),
)

app.mount('#app')
